export enum PermissionLevel {
   OWNER = 'owner',
}

export enum PermissionType {
   SERVICES = 'services',
}
